import React, { useRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router";
import { GetPartyDetail } from "~slices/Party";
import { getLocalStorage } from "../../stores/Information";
import { formatDate, formatTime } from "~/functions/FormatDate";
import { PartyDetailSet, UpdatePartyDetail } from "~slices/PartyDetail";

const PartyDetail = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const search = useLocation().search;
    const query = new URLSearchParams(search);
    const party_id = query.get("party_id");

    const party_state = useSelector((state) => state.Party);

    const informationState = useSelector((state) => state.Information);
    const party_data = party_state?.party_detail;
    const party_detail_state = useSelector((state) => state.PartyDetail);

    useEffect(() => {
        //ログインしていないならログイン画面へ
        if(!getLocalStorage("organizer"))
        {
            history.push(`/Login`);
            return;
        }

        if(informationState["organizer"]["user_login"] === true)
        {
            dispatch(GetPartyDetail({ party_id: party_id })).then((data) => {
                if(data.payload.result === 'NG')
                {
                    if(data.payload.message)
                    {
                        alert(data.payload.message);
                    }
                    LinkClick();
                }

                dispatch(PartyDetailSet(['party_id', party_id]));
                dispatch(PartyDetailSet(['organizer_id', informationState["organizer"]["organizer_id"]]));
                dispatch(PartyDetailSet(['wfpf_number', data.payload.party.wfpf_number]));

                if(data.payload.menu_group)
                {
                    const menu_group = data.payload.menu_group;
                    dispatch(PartyDetailSet(['menu_group_name', menu_group.menu_group_name]));
                }
                if(data.payload.menu_data)
                {
                    const menu_data = data.payload.menu_data;
                    let select_menu_data = [];
                    menu_data.map((item) => {
                        select_menu_data = [...select_menu_data, item.menu_name];
                    }
                    );
                    dispatch(PartyDetailSet(['select_menu_data', select_menu_data]));
                }
            });
        }
    }, [informationState]);

    //戻る
    const LinkClick = () => {
        if(query.get("page"))
        {
            const params = {
                page: query.get("page")
            };
            const urlSearchParam = new URLSearchParams(params).toString();
            history.push(`/PartyList?${urlSearchParam}`);
        }
        else
        {
            history.push(`/PartyList`);
        }
    };

    //参加者一覧
    const MemberManagementClick = () => {
        const params = {
            party_id: party_id,
            page: query.get("page") ? query.get("page") : "1"
        };
        const urlSearchParam = new URLSearchParams(params).toString();

        history.push(`/MemberManagement?${urlSearchParam}`);
    };

    const HandleSubmit = (e) => {
        e.preventDefault();

        if(confirm('入力内容で登録内容を変更します。よろしいですか？'))
        {
            //更新処理
            dispatch(UpdatePartyDetail(party_detail_state)).then((data) => {
                const result = data.payload.result;
                if(result === 'OK')
                {
                    alert('変更が完了しました。');
                }
                else
                {
                    //NGメッセージ表示
                    alert(data.payload.message);
                }
            });
        }
    };

    //値変更
    const onChange = (params) => {
        const { name, value } = params;
        dispatch(PartyDetailSet([name, value]));
    };

    return (
        <React.Fragment>
            <Typography variant="h2" align="center">
                お申込み詳細
            </Typography>
            <Button size="small" variant="outlined" onClick={LinkClick}>
                戻る
            </Button>
            <Grid container direction="row" justifyContent="flex-end" alignItems="center" sx={{ mb: 3 }}>
                <Button
                    variant="outlined"
                    fullWidth sx={{ maxWidth: "10rem" }}
                    onClick={MemberManagementClick}
                >
                    参加者一覧
                </Button>
            </Grid>
            <Box sx={{ p: 2, maxWidth: "650px", marginRight: "auto", marginLeft: "auto" }}>
            <Grid container direction="column" justifyContent="center" sx={{ p: 2 }}>
                <Typography variant="h5" gutterBottom component="div">
                    参加登録フォーム
                </Typography>

                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    //sx={{ maxWidth: "10rem" }}
                    style={{'wordBreak': 'break-word'}}
                >
                    <a href={"/Member/Form/" + party_data?.attendance_form_token}>{window.location.origin + "/Member/Form/" + party_data?.attendance_form_token}</a>
                </Grid>
            </Grid>
            </Box>
            <Grid container>
                <Box sx={{ p: 2, border: "solid 1px", marginRight: "auto", marginLeft: "auto" }}>
                    ●参加案内メール　テンプレート
                    <br />
                    オンライン懇親会を下記の通り開催いたします。
                    <br />
                    開催名：{party_data?.party_name}
                    <br />
                    開催日：{formatDate(new Date(party_data?.party_date), 'YYYY/MM/DD')}{"　"}
                    {formatTime(new Date(party_data?.party_date + ' ' + party_data?.party_start_time))}{"～"}
                    <br />
                    懇親会詳細-------------------------
                    <br />
                    {party_data?.description}
                    <br />
                    -----------------------------------------
                    <br />
                    ご多用のところお手数ですが、参加登録をお願いいたします。
                    <br />
                    【{formatDate(new Date(party_data?.attendance_deadline_date), 'YYYY/MM/DD')}の16:00まで】に以下のURLからご登録ください。
                    <br />
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ maxWidth: "20rem" }}
                        style={{'wordBreak': 'break-word'}}
                    >
                        {window.location.origin + "/Member/Form/" + party_data?.attendance_form_token}
                    </Grid>
                    <br />
                    ※締切までにご登録が間に合わなかった方は、キャンセル扱いとさせていただきます。
                    <br />
                </Box>
            </Grid>
            <Box sx={{ p: 2, maxWidth: "650px", marginRight: "auto", marginLeft: "auto" }}>
                <form onSubmit={HandleSubmit} id="PartyDetailFixForm">
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        //alignItems="center"
                        sx={{ maxWidth: "50rem" }}
                    >
                        <Typography variant="h6" gutterBottom component="div">
                            {"開催日"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            {formatDate(new Date(party_data?.party_date), 'YYYY/MM/DD')}
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{borderTop: "2px solid #ccc"}}>
                            {"開始時間"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            {formatTime(new Date(party_data?.party_date + ' ' + party_data?.party_start_time))}
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{borderTop: "2px solid #ccc"}}>
                            {"開催名"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            {party_data?.party_name}
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{borderTop: "2px solid #ccc"}}>
                            {"懇親会の説明"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            {party_data?.description ? party_data.description : "記入なし"}
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{borderTop: "2px solid #ccc"}}>
                            {"ご選択の商品"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            コース：{party_detail_state.menu_group_name}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            参加者様が選択可能なプラン：
                            {party_detail_state.select_menu_data?.map((val) => (
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }} key={val}>
                                    <li>{val}</li>
                                </Typography>
                            ))}
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{borderTop: "2px solid #ccc"}}>
                            {"参加予定人数"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            {party_data?.planned_number}人
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{borderTop: "2px solid #ccc"}}>
                            {"WFPF承認番号*"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            <TextField
                                required
                                sx={{ mb: 3, fontSize: "1.2rem" }}
                                label={false}
                                variant="outlined"
                                name="wfpf_number"
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 20, pattern: "^[0-9]{20}$", title: "半角数字20桁" }}
                                value={party_detail_state.wfpf_number}
                                onChange={(e) => onChange({ name: "wfpf_number", value: e.target.value })}
                            />
                            <Button
                                variant="contained"
                                type="submit"
                                form="PartyDetailFixForm"
                                sx={{ maxWidth: "10rem" }}
                            >
                                更新
                            </Button>
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{borderTop: "2px solid #ccc"}}>
                            {"お支払い方法"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            <Typography variant="h5" gutterBottom component="div" style={{ display: party_data?.payment_bill_flag === "1" ? '' : 'none' }}>
                                {"請求書："}{party_data?.payment_bill_company}{"　"}{informationState["organizer"]["business_name"]}
                            </Typography>
                            <Typography variant="h5" gutterBottom component="div" style={{ display: party_data?.payment_paypay_flag === "1" ? '' : 'none' }}>
                                {"PayPay"}
                            </Typography>
                            <Typography variant="h5" gutterBottom component="div" style={{ display: party_data?.payment_others_flag === "1" ? '' : 'none' }}>
                                {"その他："}{party_data?.payment_others_detail}
                            </Typography>
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{borderTop: "2px solid #ccc"}}>
                            {"ご連絡先"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            {informationState["organizer"]["email_address"]}
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{borderTop: "2px solid #ccc"}}>
                            {"クーポンコード"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            {party_data?.coupon_code ? party_data.coupon_code : "記入なし"}
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{borderTop: "2px solid #ccc"}}>
                            {"ご質問やお問い合わせ"}
                        </Typography>
                        <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                            {party_data?.inquiry ? party_data.inquiry : "記入なし"}
                        </Typography>
                    </Grid>
                </form>

                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    sx={{ p: 2, border: "solid 1px ", marginRight: "auto", marginLeft: "auto", mb: 3 }}
                    style={{padding: "1rem 1rem"}}
                >
                    {"●開催までの流れ"}
                    <br/>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        sx={{ maxWidth: "50rem" }}
                        style={{padding: "1rem 0rem"}}
                    >
                        {"参加登録〆切"}
                        <br/>
                        {"　"}{formatDate(new Date(party_data?.attendance_deadline_date), 'YYYY/MM/DD')}{"　16:00"}
                    </Grid>
                    <li>
                        {"〆切の3日前・前日に、参加登録状況を幹事様にメールでお知らせいたします。"}
                    </li>
                    <li>
                        {"〆切後、確定した参加人数を幹事様にメールでお知らせいたします。"}
                    </li>
                </Grid>
            </Box>
        </React.Fragment>
    );
};

export default PartyDetail;


